module.exports = __webpack_public_path__ + "img/s5.c090c73c.svg";